import React from "react";
import { graphql, useFragment } from "react-relay";
import { WidgetFilePage_page$key } from "./__generated__/WidgetFilePage_page.graphql";
import { useWidgetLayout } from "../WidgetLayoutContext";
import { ActivityIndicator, Pressable, View } from "react-native";
import { WidgetFilePageProcessing_file$key } from "./__generated__/WidgetFilePageProcessing_file.graphql";
import { AHText, Box, RemoteImage } from "arkh";

export const WidgetFilePage = React.memo(WidgetFilePageC);
function WidgetFilePageC(props: {
  page: WidgetFilePage_page$key;
  fileId: string;
  onPress: (fileId: string, pageId: string) => void;
}) {
  const page = useFragment(
    graphql`
      fragment WidgetFilePage_page on FilePage {
        id
        image {
          id
          ...Image_image
        }
      }
    `,
    props.page
  );

  const layout = useWidgetLayout();

  if (!page.image) {
    return null;
  }
  return (
    <Pressable
      onPress={() => {
        props.onPress(props.fileId, page.id);
      }}
    >
      <RemoteImage
        image={page.image}
        style={{ height: layout.height, width: layout.width }}
        contentFit="contain"
        responsivePolicy="live"
        transition={{ duration: 400, timing: "ease-in-out" }}
      />
    </Pressable>
  );
}

export function WidgetFilePageProcessing(props: {
  file: WidgetFilePageProcessing_file$key;
}) {
  const file = useFragment(
    graphql`
      fragment WidgetFilePageProcessing_file on File {
        status
      }
    `,
    props.file
  );

  const layout = useWidgetLayout();

  return (
    <View
      style={{
        width: layout.width,
        height: layout.height,
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box>
        <AHText type="title-small">Processing</AHText>
        <Box spaceTop="small">
          <ActivityIndicator />
        </Box>
      </Box>
    </View>
  );
}
